module.exports = __webpack_public_path__ + "static/clickmaps2-dccfd90dfdc9aed063981d04f5970d90.png";